<script>
	import { Router, Link, Route, navigate } from "svelte-navigator";
	import { onMount } from 'svelte';
	import { fade } from 'svelte/transition';
	import { selectedSeason, raceResultsStore as data } from './stores';
	import RaceList from './routes/Racelist.svelte';
	import Rankings from './routes/Rankings.svelte';
	import CategoryList from './routes/CategoryList.svelte';
	import RaceInfo from './routes/RaceInfo.svelte';
	import About from './routes/About.svelte';
	
	const allDataURL = 'race_results/race_results_all.json';
	//const allDataURL = 'race_results/race_results_' + $selectedSeason + '.json';

	$: updateStore(allDataURL);

	async function getData(url) {
		let response = await fetch(url);
		let data = await response.json();
		return data;
	}

	async function updateStore(url) {
  	$data = await getData(url);
	}	

	//button scripts
	let activeButton = 'racelist';

	function setSelectedYear() {
		selectedSeason.set(document.getElementById("yearSelect").value);
		//wait for some time
		updateStore('race_results/race_results_' + $selectedSeason + '.json');
		navigate("/", { replace: true });
		activeButton = 'racelist';
	}
	// end button scripts
</script>
<!--<div>-->
	<Router>
		<!--<div class="container px-0">-->
			<!--<div class="container px-0">-->
				<!--<div class="container px-0 sticky-top">-->
				<header class="border header-background">
					<div style="display:inline-flex; align-items: center;">
						<!--<div><span style="font-size: 2.0rem;">7</span> RACES</div>-->
						<a href="/" class="d-flex align-items-center ms-1 mb-1 mb-md-0 me-md-auto text-dark text-decoration-none">
							<img src="logo.png" alt="logo" width="120" height="120">
							<span class="fs-3">MTB Uphill Challenge</span>
						</a>
						<!--<div><span style="font-size: 2.0rem;">233</span> RIDERS</div>-->
					</div>
				</header>
				<div class="bg-secondary sticky-top text-center pt-1 pb-1">
					<!--<div>
						<select id="yearSelect" class="form-select form-select-lg mb-3" aria-label=".form-select-lg example" on:change="{() => setSelectedYear()}">
							<option selected value="2023">2023</option>
							<option value="2022">2022</option>
						</select>
					</div>-->
					<div>
						<ul class="nav" style="display:inline-flex;">
						<!--<li class="nav-item">
								<select id="yearSelect" class="form-select form-select-lg mb-3" aria-label=".form-select-lg example" on:change="{() => setSelectedYear()}">
									<option selected value="2023">2023</option>
									<option value="2022">2022</option>
								</select>
						</li>		-->
						<!--
						<div class="dropdown">
							<a class="btn btn-secondary dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
								Season
							</a>

							<ul class="dropdown-menu">
								<li><a class="dropdown-item" href="#">2023</a></li>
								<li><a class="dropdown-item" href="#">2022</a></li>
							</ul>
						</div>-->
						<li class="nav-item">
							<Link class="nav-link" to="/">
								<button type="button" class="btn btn-outline-light btn-sm text-uppercase {activeButton === 'racelist' ? 'btn-active' : ''}" style="padding: 0.5rem .5rem;" on:click="{() => activeButton = 'racelist'}">Races</button>
							</Link>
						</li>						
						<li class="nav-item">
							<Link class="nav-link" to="rankings">
								<button type="button" class="btn btn-outline-light btn-sm text-uppercase {activeButton === 'rankings' ? 'btn-active' : ''}" style="padding: 0.5rem .5rem;" on:click="{() => activeButton = 'rankings'}">Rank</button>
							</Link>
						</li>					
						<li class="nav-item">
							<Link class="nav-link" to="about">
								<button type="button" class="btn btn-outline-light btn-sm text-uppercase {activeButton === 'about' ? 'btn-active' : ''}" style="padding: 0.5rem .5rem;" on:click="{() => activeButton = 'about'}">About</button>
							</Link>
						</li>
					</ul>
					</div>
					
				</div>
			<!--</div>-->
	
	
	<!--<main class="container px-0" style="background-color:rgba(0, 0, 0, 0.05); padding-top: 5px;">-->
	<main class="container px-0">
		<Route path="/">
			<div class="row pt-2 mx-0" in:fade="{{delay: 250, duration: 300}}" style="background-color: #F0EFF0;"><RaceList /></div>
		</Route>

		<Route path="rankings">
			<div class="row pt-2 mx-0" style="background-color: #F0EFF0;"><Rankings /></div>
		</Route>

		<Route path="about">
			<div class="row pt-2 mx-0" in:fade="{{delay: 250, duration: 300}}" style="background-color: #F0EFF0;"><About /></div>
		</Route>
		<Route path="category_list" component={CategoryList} />
		<Route path="race_info" component={RaceInfo} />
	</main>
<!--</div>-->
</Router>

<!--</div>-->

<style>
	main {
		text-align: center;
		padding: 0px;
		/*max-width: 100%;*/
		/*position: absolute;*/
	}

	header {
		color: #294D6A;
		padding-top: 10px;
	}

	header ul li{
    display: flex;
    flex-direction: row;
    align-items: center;
	}

	.btn-active {
		/*background-color: #294D6A;
		color: #fff;*/
		background-color: #fff;
		color: #294D6A;
	}

	@media (min-width: 640px) {
		main {
			max-width: 1199.98px;
		}
	}

	#navbar {
  	/*overflow: hidden;*/
		/*position: sticky;*/
  	/*background-color: #333;*/
		position: sticky;
		position: -webkit-sticky;
		top: 0; /* required */
	}

	.sticky {
  	/*position: fixed;*/
		position: sticky;
  	top: 10px;
  	width: 100%;
	}

	.sticky-top {
		z-index: 20;
	}


</style>